import {DatePipe} from '@angular/common';
import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AcabimProject, GenericPayloadModel, GenericPayloadType, MultifileService, MultiFileUploadComponent, ProjectApiService} from '@cas-hub/acabim-common-client';
import {ConfirmationService, MessageService, PrimeNGConfig, SelectItem} from 'primeng/api';
import {FileUsageService} from '../../../_services/file-usage.service';

@Component({
    selector: 'acabim-admin-edit-project',
    templateUrl: './edit-project.component.html',
    styleUrls: ['./edit-project.component.scss'],
    providers: [MessageService]

})
export class EditProjectComponent implements OnInit {
    @Output() closeDialog = new EventEmitter<string>();
    @Output() public closable = new EventEmitter<boolean>();

    @Input() selectedProject?: AcabimProject = undefined;
    _currentProject?: AcabimProject = undefined;
    yearRange = ((new Date()).getFullYear() - 100) + ':' + ((new Date()).getFullYear() + 10);

    public mimetypes: string[] = [
        'application/pdf',
        'image/png',
        'image/jpeg'
    ];
    @ViewChild('fileComp') public fileComponent?: MultiFileUploadComponent;
    public fullFiles: { guid: string, name: string, loading: boolean, file: any }[] = [];
    public fileGuids: string[] = [];
    disableAdd = false;

    projectPhases: { name: string, id: number }[] = [
        {
            name: 'Pre-construction Building',
            id: 0
        }, {name: 'Construction Building', id: 1}, {name: 'Existing Building', id: 2}, {
            name: 'Refurbishment Building',
            id: 3
        }];
    editProjectForm: FormGroup | undefined;
    // @ts-ignore
    private currentFile?: File;
    public fileName?: string = undefined;

    groupNames: string[] = [];
    items: SelectItem[] = [];
    uploadProgress = 0;
    showProgressBar = false;
    isLoading = false;
    displayWarning = false;
    errorMessage: GenericPayloadModel[] = [];
    errorMessageTypes = GenericPayloadType;

    public showTransferPhaseModel = false;

    constructor(private readonly projectService: ProjectApiService,
                private messageService: MessageService, private primengConfig: PrimeNGConfig, private datePipe: DatePipe,
                private readonly fileServiceCommon: MultifileService,
                private confirmationService: ConfirmationService,
                private readonly fileService: FileUsageService
    ) {
        this.editProjectForm = new FormGroup({
            projectName: new FormControl(null),
            projectDescription: new FormControl(),
            selectedBuilding: new FormControl(),
            projectGroups: new FormControl(),
            warningMessage: new FormControl({value: '', disabled: true}),
            completionDate: new FormControl(null),
            constructionDate: new FormControl(null),
            projectPhase: new FormControl(null),
            selectedDate: new FormControl(null),
        });
    }

    ngOnInit(): void {
        console.dir(this.selectedProject);
        this.primengConfig.ripple = true;
        if (this.selectedProject && this.editProjectForm) {
            this.isLoading = true;
            this.getFiles(this.selectedProject.id);
            this.projectService.getProject(this.selectedProject.id, {includeBuildingStatus: true, includeGroups: true}).subscribe(project => {
                this.isLoading = false;
                this._currentProject = project;
                this.items = [];
                this.projectService.getAllProjectGroups().subscribe(group => {
                    if (group && group.data) {
                        group.data.forEach(g => {
                            this.items.push({value: g.id, label: g.name});
                        });
                    }
                });
                if (this.editProjectForm) {
                    const groups: string[] = [];
                    this._currentProject.groups.forEach(g => {
                        if (g) {
                            groups.push(g.id);
                            this.groupNames.push(g.name);
                        }
                    });
                    this.editProjectForm.get('projectName')?.setValue(this._currentProject.name ? this._currentProject.name : '');
                    this.editProjectForm.get('projectDescription')?.setValue(this._currentProject.description ? this._currentProject.description : '');
                    this.editProjectForm.get('selectedBuilding')?.setValue(this._currentProject.buildingGuid ? this._currentProject.buildingGuid : '');
                    this.editProjectForm.get('projectGroups')?.setValue(groups);
                    switch (this._currentProject?.currentPhase) {
                        case 'Refurbishment':
                            this.editProjectForm?.get('projectPhase')?.setValue({name: 'Refurbishment Building', id: 3});
                            break;
                        case 'PostConstruction':
                            this.editProjectForm?.get('projectPhase')?.setValue({name: 'Existing Building', id: 2});
                            // @ts-ignore
                            this.editProjectForm?.get('completionDate')?.setValue(new Date(this.getDate(this._currentProject?.practicalCompletionDate)));
                            break;
                        case 'PreConstruction':
                            this.editProjectForm?.get('projectPhase')?.setValue({name: 'Pre-construction Building', id: 0});
                            break;
                        case 'Construction':
                            this.editProjectForm?.get('projectPhase')?.setValue({name: 'Construction Building', id: 1});
                            // @ts-ignore
                            this.editProjectForm?.get('constructionDate')?.setValue(new Date(this.getDate(this._currentProject?.constructionStartDate)));
                            break;
                        default:
                            break;
                    }
                }
            });
            this.editProjectForm.get('constructionDate')?.valueChanges.subscribe(v => {
                console.dir(v);
            });
        }
    }

    onCancel() {
        this.closeDialog.emit('cancel');
    }

    public onCloseUpdatePhase(value: boolean): void {
        if (!value) {
            this.showTransferPhaseModel = false;
        }
    }

    public onProjectPhaseUpdated(): void {
        this.showTransferPhaseModel = false;
        this.closeDialog.emit('update');
    }

    closeErrorDialog() {
        this.displayWarning = false;
    }

    updateProject() {
        if (this._currentProject && this.editProjectForm?.valid) {
            this.isLoading = true;
            this.projectService.updateProject(
                this._currentProject.id,
                this.editProjectForm.get('projectName')?.value,
                this.editProjectForm?.get('projectDescription')?.value,
                this.editProjectForm.get('projectGroups')?.value
                ).subscribe(data => {
                    if (this.currentFile) {
                        this.showProgressBar = true;
                        this.isLoading = false;
                    } else {
                        this.isLoading = false;
                        this.closeDialog.emit('update');
                    }
                });
        } else {
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry, cannot update the project',
                key: 'projectMessage'
            });
        }
    }

    setValidators() {
        if (this.editProjectForm?.get('projectPhase')?.value?.id === 2) {
            this.editProjectForm?.get('completionDate')?.setValidators(Validators.required);
            this.editProjectForm?.get('constructionDate')?.clearValidators();
            this.editProjectForm?.get('constructionDate')?.reset();
            this.editProjectForm?.get('completionDate')?.updateValueAndValidity();
            this.editProjectForm?.get('constructionDate')?.updateValueAndValidity();
        } else if (this.editProjectForm?.get('projectPhase')?.value?.id === 1) {
            this.editProjectForm?.get('constructionDate')?.setValidators(Validators.required);
            this.editProjectForm?.get('completionDate')?.clearValidators();
            this.editProjectForm?.get('completionDate')?.reset();

            this.editProjectForm?.get('completionDate')?.updateValueAndValidity();
            this.editProjectForm?.get('constructionDate')?.updateValueAndValidity();

        } else {
            this.editProjectForm?.get('completionDate')?.clearValidators();
            this.editProjectForm?.get('constructionDate')?.clearValidators();
            this.editProjectForm?.get('constructionDate')?.reset();
            this.editProjectForm?.get('completionDate')?.reset();

            this.editProjectForm?.get('completionDate')?.updateValueAndValidity();
            this.editProjectForm?.get('constructionDate')?.updateValueAndValidity();
        }
    }

    getDate(date: string): string {
        const newDate = new Date(date);
        return (this.datePipe.transform(newDate, 'dd/MMM/yyyy') as string);
    }


    addImages(): void {
        this.isLoading = true;
        // tslint:disable-next-line:no-non-null-assertion
        this.fileService.uploadFile(this._currentProject!.id, this.fileGuids, 'project').subscribe(data => {
            this.fileGuids = [];
            this.fullFiles = [];
            this.fileComponent?.resetImages();
            this.isLoading = false;
            // tslint:disable-next-line:no-non-null-assertion
            this.getFiles(this._currentProject!.id);
            this.messageService.clear();
            this.messageService.add({
                key: 'attachment',
                severity: 'success',
                summary: 'attachments added'
            });
        }, error => {
            this.isLoading = false;
            this.messageService.clear();
            this.messageService.add({
                key: 'attachment',
                severity: 'error',
                summary: 'Sorry, cannot proceed with current attachments'
            });
        });
    }

    getFiles(projectID: string): void {
        this.fileService.getFilesFromObject(projectID, 'project').subscribe(files => {
            files.forEach(f => {
                const attachment = f.guid;
                const index = this.fullFiles.length;
                this.fullFiles.push({guid: attachment, name: f.name, loading: true, file: null});
                this.fileServiceCommon.getFile(attachment).subscribe(file => {
                    const reader = new FileReader();
                    reader.addEventListener('load', () => {
                        this.fullFiles[index].file = reader.result;
                    }, false);

                    if (file) {
                        reader.readAsDataURL(file);
                    }
                    this.fullFiles[index].loading = false;
                }, error => {
                    this.fullFiles[index].loading = false;
                });
            });
        });
    }


    onImageFileAdded(guid: string): void {
        this.fileGuids.push(guid);
    }

    onFileDeleted(guid: string): void {
        this.deleteFile(guid);
    }

    deleteFile(guid: string): void {
        this.fileGuids.splice(this.fileGuids.indexOf(guid), 1);
        // tslint:disable-next-line:no-non-null-assertion
        this.fileService.removeFiles(this._currentProject!.id, [guid], 'project').subscribe(data => {
            this.messageService.clear();
            this.messageService.add({
                severity: 'success',
                summary: 'Attachment removed',
                key: 'projectMessage'
            });
        }, error => {
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Cannot remove attachment',
                key: 'projectMessage'
            });
        });
    }

    addToBuilding(): void {
        if (this.fileGuids.length > 0) {

            this.confirmationService.confirm({
                key: 'confirmAttachment',
                message: 'Would you like to proceed?',
                header: 'Confirmation',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.addImages();
                },
                reject: () => {
                }
            });
        }
    }

    onFileLoading($event: boolean) {
        this.disableAdd = $event;
    }

}
